import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Col,
  Row,
  Divider,
  Select,
  Checkbox,
  Space,
  Card,
  Drawer,
} from "antd";
import "./add-truck.scss";
import Fileupload from "../../common/fileupload/fileupload";
import Notification from "../../service/notification";
import * as masterDataService from "../../service/masterDataService";
import * as truckService from "../../service/fleet-management/truckService";
import EditImg from "../../assets/images/pencil-edit.svg";
import EmptyTruck from "../../assets/images/Flatted-truck.svg";
import TurkeyFlag from "../../assets/images/Turkey-flag.svg";
import UaeFlag from "../../assets/images/uae-flag.svg";
import DocFileImg from "../../assets/images/Doc-Content.svg";
import ExistsImg from "../../assets/images/exists img.svg";
import moment from "moment";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/store";
import { DocTypes, EntityTypes } from "../../constants/commonConstants";
import {
  validateName,
  validateNotEmpty,
  validateNotOnlySpaces,
} from "../../util/inputValidateUtils";
import { CloseOutlined, WarningOutlined } from "@ant-design/icons";
import * as documentUtility from "../../util/documentThumbUtility";
import { checkIsInternalSourcing } from "../../util/constantUtility";
import AutofillDocUpload from "../login/sign-up/components/autofill-doc-upload";
import DocumentListView from "../login/sign-up/components/document-list-view";
import { initialUploadState } from "./fleet-management";
import {
  ocrCustomFileUploadService,
  uploadDocumentV2,
} from "../../service/documentService";
import OCRFileUpload from "../../common/ocr-file-upload/ocr-file-upload";
import MissingDocModal from "../login/sign-up/components/missing-doc-modal";
import DiscardWarningModal from "../../common/discard-warnig-modal/discard-warning-modal";
import OCRFilePreviewUploader from "../../common/ocr-file-preview-uploader/ocr-file-preview-uploader";
import { toTitleCase } from "../../util/toTitleCase";

const dateFormat = "DD/MM/YYYY";
const { Option } = Select;

const AddTruck = ({
  isOpen,
  onClose,
  formType,
  editformValues,
  refresh,
  setTrucks,
  supplierId,
  supplierCountry,
  // OCR props
  setIsUploadingPopupVisible,
  setUploadState,
  setSamplePreviewOpen,
  setSampleType,
}) => {
  console.log("sdfgb", typeof setUploadState);
  const { t } = useTranslation();
  const [addTruckForm] = Form.useForm();
  console.log("ADD TRUCK addTruckForm", addTruckForm.getFieldValue());
  const [nextBtn, setNextBtn] = useState(
    formType === "editForm" ? true : false
  );
  const [nextBtnTwo, setNextBtnTwo] = useState(false);
  const [checked, setChecked] = useState(
    formType === "editForm" &&
      editformValues?.trailerRegCertificate?.documentNumber
      ? true
      : false
  );
  const [truckTypeWaiter, setTruckTypeWaiter] = useState(false);
  const [subTruckTypeWaiter, setSubTruckTypeWaiter] = useState(false);
  const [truckTypeOptions, setTruckTypeOptions] = useState([]);
  const [truckData, setTruckData] = useState(null);
  const [subTruckTypeOptions, setSubTruckTypeOptions] = useState([]);
  const [formValues, setFormValues] = useState({});
  console.log("ADD TRUCK formValues", formValues);
  const [cityOptions, setCityOptions] = useState([]);
  const [cityOptionsWaiter, setCityOptionsWaiter] = useState(false);
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState();
  console.log(" countryMatch countryOptions", countryOptions);
  const [truckExist, setTruckExist] = useState(false);
  console.log("TRUCK ADD truckExist", truckExist);
  const [addFleet, setAddFleet] = useState(false);
  console.log("TRUCK ADD addFleet", addFleet);
  const [truckId, setTruckId] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);
  const { user } = useStore();
  const [truckDocs, setTruckDocs] = useState([]);
  const [weight, setWeight] = useState("");
  const [weightUnits, setWeightUnits] = useState("");
  const [truckChassisNumber,setTruckChassisNumber]=useState("");
  const [truckModel,setTruckModel]=useState("");
  const [plateSequenceNumber,setPlateSequenceNumber]=useState("");
  const [motorNumber,setMotorNumber]=useState("");
  const defaultDoc = {
    docType: "INQDOC",
    fileName: "",
    fileThumbName: "",
    fileThumbURL: "",
    index: 0,
    // isInsertUpdate: false,
    // *****  OCR NEW KEY ADDED
    isInsertUpdate: false,
    isOCRDoc: false,
  };
  const [frontDocs, setFrontDocs] = useState([{ ...defaultDoc }]);
  console.log(frontDocs, "frontDocs");
  console.log(addTruckForm.getFieldsValue());
  const [isBrandNameWaiter, setIsBrandNameWaiter] = useState(false);
  const [brandName, setBrandName] = useState();

  // ******************* OCR File Uploads STATES *****************
  const [isOcrFileUpload, setIsOcrFileUpload] = useState(false);
  const [ownerType, setOwnerType] = useState("FleetTruck");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [ocrConfirmedFiles, setOcrConfirmedFiles] = useState([]);
  const [ocrParsedData, setOcrParsedData] = useState(null);
  const [ocrLogId, setOcrLogId] = useState("");
  console.log("ocrLogId", ocrLogId);
  const [showPlateMismatchModal, setShowPlateMismatchModal] = useState(false);
  const [ocrPlateNumber, setOcrPlateNumber] = useState("");

  // Drawer State
  const [openDrawer, setOpenDrawer] = useState(false);
  const [missingDocModal, setMissingDocModal] = useState(false);

  // Discard  moadl State
  const [isDiscardModalVisible, setIsDiscardModalVisible] = useState(false);

  useEffect(() => {
    if (ocrParsedData?.documents?.length) {
      const { documents } = ocrParsedData;

      // Handle TRUCK_RC documents
      const truckRCs = documents.filter(
        (doc) => doc.docType === "TRUCK_RC" && doc.status
      );
      const trailerRC = documents.find(
        (doc) => doc.docType === "TRAILER_RC" && doc.status
      );

      console.log("ADD TRUCK trailerRC", trailerRC);

      // Select first valid truck document
      const primaryTruck = truckRCs?.[0];
      const truckPlateNumber = primaryTruck?.truckPlateNumber || "";
      const truckRegExpiry = primaryTruck?.docExpiryDate
        ? dayjs(primaryTruck.docExpiryDate, "DD-MM-YYYY").format("DD/MM/YYYY")
        : null;

      // nextBtnTwo fieldValues Set
      const brandName = primaryTruck?.truckBrandName || null;
      const numberPlateIssuer = toTitleCase(primaryTruck?.truckOwner) || null;
      const manufacturingYear = primaryTruck?.truckManufacturingYear
        ? dayjs(primaryTruck.truckManufacturingYear, "YYYY").format("YYYY")
        : null;

      // ****

      const truckRegFront = {
        EntityId: "Truck",
        FileName:
          `ActualTruck/${ocrLogId}_TRFD${documentUtility.getFileExtension(
            primaryTruck?.frontUrl
          )}` || null,
        FileThumbName:
          `ActualTruck_Thumb/${ocrLogId}_TRFD${documentUtility.getFileExtension(
            primaryTruck?.frontUrl
          )}` || null,
        FileThumbURL:
          documentUtility.getThumbnailImagePath(primaryTruck?.frontUrl) || null,
        FileURL: primaryTruck?.frontUrl || null,
        Status: false,
        FileUrl: primaryTruck?.frontUrl || null,
        // isInsertUpdate: true,
        isPathSet: true,
        FileThumbUrl:
          documentUtility.getThumbnailImagePath(primaryTruck?.frontUrl) || null,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: false,
        isOCRDoc: true,
      };

      const truckRegBack = {
        EntityId: "Truck",
        FileName:
          `ActualTruck/${ocrLogId}_TRBD${documentUtility.getFileExtension(
            primaryTruck?.backUrl
          )}` || null,
        FileThumbName:
          `ActualTruck_Thumb/${ocrLogId}_TRBD${documentUtility.getFileExtension(
            primaryTruck?.backUrl
          )}` || null,
        FileThumbURL:
          documentUtility.getThumbnailImagePath(primaryTruck?.backUrl) || null,
        FileURL: primaryTruck?.backUrl || null,
        Status: false,
        FileUrl: primaryTruck?.backUrl || null,
        // isInsertUpdate: true,
        isPathSet: true,
        FileThumbUrl:
          documentUtility.getThumbnailImagePath(primaryTruck?.backUrl) || null,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: false,
        isOCRDoc: true,
      };

      if (primaryTruck) {
        setTruckChassisNumber(primaryTruck?.truckChassisNumber ?? "");
        setTruckModel(primaryTruck?.truckModel ?? "");
        setPlateSequenceNumber(primaryTruck?.plateSequenceNumber ?? "");
        setMotorNumber(primaryTruck?.motorNumber ?? "");

        setFormValues((prev) => ({
          ...prev,
          //   assetPlateNumber: truckPlateNumber,
          //   truckRegistrationNo: truckPlateNumber,
          truckRegExpiry,
          truckRegFront,
          truckRegBack,
          brandName,
          numberPlateIssuer,
          manufacturingYear,
        }));

        addTruckForm.setFieldsValue({
          //   assetPlateNumber: truckPlateNumber,
          //   truckRegistrationNo: truckPlateNumber,
          truckRegExpiry,
          truckRegFront,
          truckRegBack,
          brandName,
          numberPlateIssuer,
          manufacturingYear,
        });
      }

      // Handle TRAILER_RC
      if (trailerRC) {
        const trailerRegistrationNo = trailerRC.truckPlateNumber || "";
        const trailerExpiry = trailerRC.docExpiryDate
          ? dayjs(trailerRC.docExpiryDate, "DD-MM-YYYY").format("DD/MM/YYYY")
          : null;

        const trailerDocFront = {
          EntityId: "Truck",
          FileName:
            `ActualTruck/${ocrLogId}_TRAFD${documentUtility.getFileExtension(
              trailerRC?.frontUrl
            )}` || null,
          FileThumbName:
            `ActualTruck_Thumb/${ocrLogId}_TRAFD${documentUtility.getFileExtension(
              trailerRC?.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(trailerRC?.frontUrl) || null,
          FileURL: trailerRC?.frontUrl || null,
          Status: false,
          FileUrl: trailerRC?.frontUrl || null,
          // isInsertUpdate: true,
          isPathSet: true,
          FileThumbUrl:
            documentUtility.getThumbnailImagePath(trailerRC?.frontUrl) || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const trailerDocBack = {
          EntityId: "Truck",
          FileName:
            `ActualTruck/${ocrLogId}_TRABD${documentUtility.getFileExtension(
              trailerRC?.backUrl
            )}` || null,
          FileThumbName:
            `ActualTruck_Thumb/${ocrLogId}_TRABD${documentUtility.getFileExtension(
              trailerRC?.backUrl
            )}` || null,
          FileThumbURL: trailerRC?.backUrl || null,
          FileURL: trailerRC?.backUrl || null,
          Status: false,
          FileUrl: trailerRC?.backUrl || null,
          // isInsertUpdate: true,
          isPathSet: true,
          FileThumbUrl:
            documentUtility.getThumbnailImagePath(trailerRC?.backUrl) || null,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setChecked(true);

        setFormValues((prev) => ({
          ...prev,
          trailerRegistrationNo,
          trailerExpiry,
          trailerDocFront,
          trailerDocBack,
        }));

        addTruckForm.setFieldsValue({
          trailerRegistrationNo,
          trailerExpiry,
          trailerDocFront,
          trailerDocBack,
        });
      }
    }
  }, [ocrParsedData]);

  //    Check plate mismatch and change update value based on the need
  useEffect(() => {
    if (ocrParsedData?.documents?.length) {
      const { documents } = ocrParsedData;

      // Handle TRUCK_RC documents
      const truckRCs = documents.filter(
        (doc) => doc.docType === "TRUCK_RC" && doc.status
      );

      console.log("truckRCs", truckRCs);

      const trailerRC = documents.find(
        (doc) => doc.docType === "TRAILER_RC" && doc.status
      );

      // Select first valid truck document
      const primaryTruck = truckRCs?.[0];
      const truckPlateNumber = primaryTruck?.truckPlateNumber || "";

      // Country SetUp on OCR Data
     // if (primaryTruck?.issueCountry) {
     if (primaryTruck?.registrationCountry) {
        const countryMatch = countryOptions.find(
          (opt) =>
            opt.name.trim().toLowerCase() ===
            primaryTruck.registrationCountry.trim().toLowerCase()
        );

        if (countryMatch) {
          console.log("countryMatch", countryMatch);
          setFormValues((prev) => ({
            ...prev,
            registrationCountry: countryMatch.name,
            registrationCountryCode: countryMatch.country_code,
          }));

          addTruckForm.setFieldsValue({
            registrationCountry: countryMatch.name,
            registrationCountryCode: countryMatch.country_code,
          });

          addTruckForm.validateFields(["registrationCountry"]);
          setCityOptions([]);
          getCityList(countryMatch.country_code, undefined, primaryTruck?.issueCity);
        } else {
          console.warn(
            "IssueCountry not found in countryOptions:",
            primaryTruck.issueCountry
          );
        }
      }

      if (
        formValues?.assetPlateNumber &&
        truckPlateNumber &&
        truckPlateNumber !== formValues?.assetPlateNumber
      ) {
        setOcrPlateNumber(truckPlateNumber);
        setShowPlateMismatchModal(true);
        return;
      }
    }
  }, [ocrParsedData]);

  useEffect(() => {
    getCountries();
    getTruckType();
  }, []);

  useEffect(() => {
    if (editformValues) {
      // Map editformValues to form fields
      const formattedValues = {
        assetPlateNumber: editformValues.assetPlateNumber,
        truckType: editformValues.truckType,
        subTruckType: editformValues.subTruckType,
        truckRegistrationNo: editformValues.regCertificate?.documentNumber,
        truckRegExpiry: editformValues.regCertificate?.expiryDate
          ? moment(editformValues.regCertificate?.expiryDate).format(dateFormat)
          : null,
        truckRegFront: {
          FileName: editformValues.regCertificate?.frontDoc?.fileName,
          FileURL: editformValues.regCertificate?.frontDoc?.documentPath,
          FileThumbURL:
            editformValues.regCertificate?.frontDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        truckRegBack: {
          FileName: editformValues.regCertificate?.backDoc?.fileName,
          FileURL: editformValues.regCertificate?.backDoc?.documentPath,
          FileThumbURL:
            editformValues.regCertificate?.backDoc?.documentPathThumb,
          isInsertUpdate: false,
        },
        manufacturingYear: editformValues.manufacturingYear
          ? editformValues.manufacturingYear
          : null,
        registrationCountry: editformValues.registrationCountry,
        registrationCountryCode: editformValues.registrationCountryCode,
        registrationCity: editformValues.registrationCity,
        numberPlateIssuer: editformValues.plateNumberIssuerName,
        brandName: editformValues.brandName,
        ...(editformValues.trailerRegCertificate && {
          trailerRegistrationNo:
            editformValues.trailerRegCertificate?.documentNumber,
          trailerExpiry: editformValues.trailerRegCertificate?.expiryDate
            ? moment(editformValues.trailerRegCertificate?.expiryDate).format(
                dateFormat
              )
            : null,
          trailerDocFront: {
            FileName: editformValues.trailerRegCertificate?.frontDoc?.fileName,
            FileURL:
              editformValues.trailerRegCertificate?.frontDoc?.documentPath,
            FileThumbURL:
              editformValues.trailerRegCertificate?.frontDoc?.documentPathThumb,
            isInsertUpdate: false,
          },
          trailerDocBack: {
            FileName: editformValues.trailerRegCertificate?.backDoc?.fileName,
            FileURL:
              editformValues.trailerRegCertificate?.backDoc?.documentPath,
            FileThumbURL:
              editformValues.trailerRegCertificate?.backDoc?.documentPathThumb,
            isInsertUpdate: false,
          },
        }),
      };
      setWeight(editformValues.weight ? editformValues.weight : "");
      setWeightUnits(
        editformValues.weightUnits ? editformValues.weightUnits : ""
      );
      setTruckChassisNumber(editformValues?.chasisNo ?? "");
      setTruckModel(editformValues?.model ?? "");
      setPlateSequenceNumber(editformValues?.plateSequenceNumber ?? "");
      setMotorNumber(editformValues?.motorNo ?? "");
      addTruckForm.setFieldsValue(formattedValues);
      setFormValues(formattedValues);
    }
  }, []);

  // On edit the registration country is prefilled but its city list was never
  // fetched, so the city dropdown rendered empty. Resolve the code the same way
  // the country dropdown's onChange does — the code stored on the truck
  // (e.g. "UAE") is not always the one the city master expects.
  const editCityListLoaded = useRef(false);
  useEffect(() => {
    if (!editformValues || editCityListLoaded.current) return;
    if (!countryOptions?.length) return;

    const countryCode =
      countryOptions.find(
        (item) =>
          item?.name?.trim().toLowerCase() ===
          editformValues?.registrationCountry?.trim().toLowerCase()
      )?.country_code || editformValues.registrationCountryCode;

    console.log("EDIT TRUCK city list country code", countryCode);

    if (countryCode) {
      editCityListLoaded.current = true;
      getCityList(countryCode);
    }
  }, [countryOptions]);

  console.log(addTruckForm.getFieldsValue, "addfr");
  useEffect(() => {
    getBrandName();
  }, [isOpen]);

  // const handleBrandName = (val, option) => {
  //     addTruckForm.setFieldsValue({ Truck_Modal: null });
  //     setSelectedBrand({
  //       Name: option.make_name,
  //       Value: option.make_id.toString(),
  //     });
  //   };

  const disablePastDates = (current) => {
    return current && current <= dayjs().endOf("day");
  };

  const handleFormChange = (fieldName, val) => {
    console.log(fieldName, val, "filesld");
    addTruckForm.setFieldValue(fieldName, val);
    setFormValues((prev) => ({
      ...prev,
      [fieldName]: val,
    }));
    addTruckForm.validateFields([fieldName]);
  };

  const getCountries = () => {
    setCountriesListWaiter(true);
    masterDataService
      .getCountryMaster()
      .then((res) => {
        setCountriesListWaiter(false);
        if (res.status === 200) {
          setCountryOptions(res.data);
          let countries = [];
          user?.dataProtectionDetail?.country?.forEach((ele) => {
            countries.push(ele);
          });
          user?.dataProtectionDetail?.externalShipperMasterIds?.forEach(
            (ele) => {
              if (!countries?.includes(ele.country)) {
                countries.push(ele.country);
              }
            }
          );
          let localCountries = res.data.filter(
            (ele) => countries?.indexOf(ele.name) !== -1
          );
          // setCountries(localCountries);
        }
      })
      .catch((err) => {
        setCountriesListWaiter(false);
      });
  };

  const getCityList = (value, index, cityToMatch) => {
    setCityOptionsWaiter(true);
    masterDataService
      .getCityMasterByCountry(value)
      .then((response) => {
        if (response.status === 200) {
          setCityOptionsWaiter(false);
          setCityOptions(response.data);

          // Select the city coming from OCR, if it exists in the master list
          if (cityToMatch) {
            const cityMatch = response.data?.find(
              (city) =>
                city?.name?.trim().toLowerCase() ===
                cityToMatch.trim().toLowerCase()
            );

            if (cityMatch) {
              setFormValues((prev) => ({
                ...prev,
                registrationCity: cityMatch.name,
              }));
              addTruckForm.setFieldsValue({ registrationCity: cityMatch.name });
              addTruckForm.validateFields(["registrationCity"]);
            } else {
              console.warn("IssueCity not found in cityOptions:", cityToMatch);
            }
          }
        }
      })
      .catch((error) => {
        setCityOptionsWaiter(false);
        setCityOptions([]);
      });
  };

  const getSubTruckType = (truckType) => {
    setSubTruckTypeWaiter(true);
    masterDataService
      .getSubTruckType(truckType)
      .then((response) => {
        if (response.status === 200) {
          setSubTruckTypeWaiter(false);
          const result = response.data?.map((item, index) => ({
            value: item.subTruckType,
            label: item.subTruckType,
            weight: item.weight ? item.weight : "",
            unit: item.weightUnits == "ton" ? "ton" : "",
            key: index,
          }));
          setSubTruckTypeOptions(result);
        }
      })
      .catch((error) => {
        setSubTruckTypeWaiter(false);
      });
  };

  const getTruckType = () => {
    setTruckTypeWaiter(true);
    masterDataService
      .getTruckType()
      .then((response) => {
        if (response.status === 200) {
          setTruckTypeWaiter(false);
          let operatingCountry = checkIsInternalSourcing(user?.userRole)
            ? supplierCountry?.toLowerCase()
            : user?.operatingCountry?.toLowerCase();
          if (operatingCountry === "turkey") {
            let turkeyTruckType = response?.data?.filter(
              (item, index) => item.region === "TR"
            );
            setTruckTypeOptions(turkeyTruckType);
          } else if (operatingCountry === "kazakhstan") {
            let kazakTruckType = response?.data?.filter(
              (item, index) => item.region === "KAZ"
            );
            setTruckTypeOptions(kazakTruckType);
          } else if (operatingCountry === "jordan") {
            let jordanTruckType = response.data.filter(
              (item, index) => item.region === "Jordan"
            );
            setTruckTypeOptions(jordanTruckType);
          } else if (operatingCountry === "egypt") {
            let egyptTruckType = response.data.filter(
              (item, index) => item.region === "Egypt"
            );
            setTruckTypeOptions(egyptTruckType);
          } else {
            let gccTruck = response?.data?.filter(
              (item, index) => item.region == "GCC"
            );
            setTruckTypeOptions(gccTruck);
          }
        }
      })
      .catch((error) => {
        setTruckTypeWaiter(false);
      });
  };

  const buildPayload = (values) => {
    console.log(values, "valuesTruck");
    const payload = {
      ocrLogId: ocrLogId || "", // New KEY OCR

      supplierId: supplierId ? supplierId : null,
      truckId: editformValues ? editformValues?.truckId : "",
      assetPlateNumber: values.assetPlateNumber,
      truckType: editformValues
        ? values?.truckType
        : truckTypeOptions.find((item) => item.type_id === values?.truckType)
            .type,
      subTruckType: values.subTruckType,
      supplierName: "",
      supplierCountryCode: "",
      regCertificate: {
        associateId: "",
        documentNumber: values.truckRegistrationNo,
        expiryDate: moment(values.truckRegExpiry, dateFormat).format(
          "YYYY-MM-DD"
        ),
        frontDoc: {
          // isInsertUpdate: values.truckRegFront?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.truckRegFront?.FileURL,
          documentPathThumb: values.truckRegFront?.FileThumbURL,
          fileName: values.truckRegFront?.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.truckRegFront?.isInsertUpdate || false,
          isOCRDoc: values?.truckRegFront?.isOCRDoc,
        },
        backDoc: {
          // isInsertUpdate: values.truckRegBack?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.truckRegBack?.FileURL,
          documentPathThumb: values.truckRegBack?.FileThumbURL,
          fileName: values.truckRegBack?.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.truckRegBack?.isInsertUpdate || false,
          isOCRDoc: values?.truckRegBack?.isOCRDoc,
        },
      },
      isTrailerDocument: checked,
      manufacturingYear: values.manufacturingYear,
      registrationCountryCode: values.registrationCountryCode,
      registrationCountry: values.registrationCountry,
      registrationCity: values.registrationCity,
      plateNumberIssuerName: values.numberPlateIssuer,
      brandName: values.brandName,
      isActive: true,
      weight: weight ? weight?.toString() : "",
      weightUnits: weightUnits ? weightUnits : "",
      chasisNo:truckChassisNumber ? truckChassisNumber:"",
      model:truckModel ? truckModel:"",
      plateSequenceNumber:plateSequenceNumber ? plateSequenceNumber:"",
      motorNo:motorNumber ? motorNumber:""
    };

    if (checked) {
      payload.trailerRegCertificate = {
        associateId: "",
        documentNumber: values.trailerRegistrationNo,
        expiryDate: moment(values.trailerExpiry, dateFormat).format(
          "YYYY-MM-DD"
        ),
        frontDoc: {
          // isInsertUpdate: values.trailerDocFront?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.trailerDocFront?.FileURL,
          documentPathThumb: values.trailerDocFront?.FileThumbURL,
          fileName: values.trailerDocFront?.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.trailerDocFront?.isInsertUpdate || false,
          isOCRDoc: values?.trailerDocFront?.isOCRDoc,
        },
        backDoc: {
          // isInsertUpdate: values.trailerDocBack?.isInsertUpdate,
          isPathSet: true,
          documentPath: values.trailerDocBack?.FileURL,
          documentPathThumb: values.trailerDocBack?.FileThumbURL,
          fileName: values.trailerDocBack?.FileName,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: values?.trailerDocBack?.isInsertUpdate || false,
          isOCRDoc: values?.trailerDocBack?.isOCRDoc,
        },
      };
    } else {
      payload.trailerRegCertificate = null;
    }

    return payload;
  };

  const onSubmitHandler = async () => {
    const currentValues = addTruckForm.getFieldsValue();
    let mergedValues = { ...formValues, ...currentValues };

    if (nextBtn) {
      addTruckForm
        .validateFields()
        .then(() => {
          setFormValues(mergedValues);
          setNextBtnTwo(true);
          setNextBtn(false);
        })
        .catch((error) => {
          setBtnLoader(false);
        });
    } else if (nextBtnTwo || formType === "editForm") {
      addTruckForm
        .validateFields()
        .then(() => {
          setBtnLoader(true);
          const payload = buildPayload(mergedValues);

          truckService
            .addTruckOnboard(payload)
            .then((res) => {
              if (res?.status === 200) {
                setBtnLoader(false);
                debugger;
                Notification.success(
                  t("SUCCESS_KEY"),
                  `${t("TRUCK_KEY")} ${
                    formType === "editForm"
                      ? t("DETAIL_UPDATED_KEY")
                      : t("ADDED_KEY")
                  } ${t("TO_FLEET_KEY")} .`
                );
                onClose();
                if (!editformValues) {
                  setTrucks([]);
                }
                refresh();
              }
            })
            .catch((error) => {
              setBtnLoader(false);
            });
        })
        .catch((error) => {
          if (error?.errorFields?.length > 0) {
            addTruckForm.scrollToField(error.errorFields[0].name[0]);
          }
        });
    } else {
      const values = addTruckForm.getFieldsValue();
      addTruckForm
        .validateFields()
        .then(() => {
          setBtnLoader(true);
          const payload = {
            assetPlateNumber: values?.assetPlateNumber,
            supplierId: supplierId ? supplierId : "",
          };
          debugger;
          truckService
            .CheckTruckExist(payload)
            .then((response) => {
              debugger;
              if (response.status === 200) {
                if (response?.data?.data?.isTruckExist) {
                  setBtnLoader(false);
                  setTruckId(response?.data?.data);

                  setTruckExist(true);
                } else if (!response?.data?.data?.isTruckExist) {
                  setBtnLoader(false);
                  debugger;
                  //   setNextBtn(true);
                  setIsOcrFileUpload(true);
                }
              }
            })
            .catch((err) => {
              debugger;
              setBtnLoader(false);
              // onClose();
            });
        })
        .catch((error) => {
          addTruckForm.scrollToField(error.errorFields[0].name[0]);
        });
    }
  };

  const addTruckinFleetHandler = () => {
    if (addFleet) {
      setBtnLoader(true);
      const payload = {
        assetPlateNumber: truckData?.assetPlateNumber,
        supplierId: supplierId ? supplierId : "",
      };
      truckService
        .addTruckInFleet(payload)
        .then((response) => {
          if (response.status === 200) {
            setBtnLoader(false);
            debugger;
            Notification.success(t("SUCCESS_KEY"), t("TRUCK_ADDED_FLEET_KEY"));
            onClose();
            setTrucks([]);
            refresh();
          }
        })
        .catch((err) => {
          setBtnLoader(false);
        });
    } else {
      setBtnLoader(true);
      truckService
        .getTruckById(truckId?.truckId)
        .then((response) => {
          if (response.status === 200) {
            setBtnLoader(false);
            setAddFleet(true);
            setTruckData(response?.data?.data);
            const { drivingLicense, nationalID, passport, visa } =
              response?.data?.data || {};

            // Combine all documents into one array
            const allDocs = [
              { type: "Driving License", ...drivingLicense },
              { type: "National ID", ...nationalID },
              { type: "Passport", ...passport },
              ...visa.map((v) => ({ type: "Visa", ...v })),
            ];

            // Save the combined documents
            setTruckDocs(allDocs);
          }
        })
        .catch((err) => {
          setBtnLoader(false);
        });
    }
  };

  // const onFileUploadDocs = (file, fieldName) => {
  //     console.log(file , fieldName ,"fileandfieldname")
  //     var updatedInquiryDocs = [...frontDocs];
  //     updatedInquiryDocs[0] = {
  //         DocType: file.DocType,
  //         FileName: file.FileName,
  //         FileThumbName: file.FileThumbName,
  //         FileURL: file.FileURL,
  //         size: file.size,
  //         EntityId: file.EntityId,
  //         FileThumbURL: file.FileThumbURL,
  //         isInsertUpdate:true
  //     };
  //     setFrontDocs(updatedInquiryDocs);

  //     // setFormValues((prev) => ({
  //     //     ...prev,
  //     //     [fieldName]: {
  //     //         FileName: file?.FileName,
  //     //         FileURL: file?.FileURL,
  //     //         FileThumbURL: file?.FileThumbURL,
  //     //     },
  //     // }));
  //     console.log("setting Field now")
  //     addTruckForm.setFieldValue({
  //         [fieldName]:{
  //         DocType: file.DocType,
  //         FileName: file.FileName,
  //         FileThumbName: file.FileThumbName,
  //         FileURL: file.FileURL,
  //         isInsertUpdate:true,
  //        isPathSet:true,
  //         EntityId: file.EntityId,
  //         FileThumbURL: file.FileThumbURL,

  //     }

  // });
  // };

  const onFileUploadDocs = (file, fieldName) => {
    var updatedInquiryDocs = [...frontDocs];
    updatedInquiryDocs[0] = {
      docType: file.docType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      // isInsertUpdate: true,
      size: file.size,
      EntityId: file.EntityId,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.FileData,
      // *****  OCR NEW KEY ADDED
      isInsertUpdate: true,
      isOCRDoc: false,
    };
    setFrontDocs(updatedInquiryDocs);
    addTruckForm.setFieldsValue({
      [fieldName]: {
        DocType: file.docType,
        FileName: file.FileName,
        FileThumbName: file.FileThumbName,
        FileUrl: file.FileURL,
        // isInsertUpdate: true,
        isPathSet: true,
        EntityId: file.EntityId,
        FileThumbUrl: file.FileThumbURL,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: true,
        isOCRDoc: false,
      },
    });
    // setFormValues((prev) => ({
    //   ...prev,
    //   [fieldName]: {
    //     FileName: file?.FileName,
    //     FileURL: file?.FileURL,
    //     FileThumbURL: file?.FileThumbURL,
    //     isInsertUpdate: true,
    //     isPathSet: true
    //   },
    // }));
  };

  const getBrandName = () => {
    setIsBrandNameWaiter(true);
    masterDataService
      .getBrandNameMaster()
      .then((response) => {
        setIsBrandNameWaiter(false);
        setBrandName(response.data);
      })
      .catch((error) => {
        setIsBrandNameWaiter(false);
        // message.error(t("ERROR_MESSAGE"));
      });
  };
  //   const disabledDate = (current) => {
  //     return current && current > dayjs().endOf("day");
  //   };

  const disabledDate = (current) => {
    const fiftyYearsAgo = dayjs().subtract(50, "year").startOf("year");
    const today = dayjs().endOf("day");
    return current && (current < fiftyYearsAgo || current > today);
  };

  // ***************** OCR FILE UPLOAD HANDLED *******************
  const handleFileChange = (newFiles) => {
    setUploadedFileData((prev) => [...prev, ...newFiles]);
  };

  const handleFileDelete = (fileNameToDelete) => {
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };

  const handleOCRConformFileChange = (newFiles) => {
    console.log("handleOCRConformFileChange", newFiles);
    setOcrConfirmedFiles((prev) => [...prev, ...newFiles]);
  };

  const handleOCRConfirmFileDelete = (fileNameToDelete) => {
    setOcrConfirmedFiles((prev) =>
      // prev.filter((_, index) => index !== indexToDelete)
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };

  const handleViewSampleClick = (type) => {
    setSampleType(type);
    setSamplePreviewOpen(true);
  };

  const onClickProceed = () => {
    if (uploadedFileData.length === 0) {
      Notification.warning("Warning", "Please upload at least one document.");
      return;
    }

    setOcrConfirmedFiles([...uploadedFileData]);
    // setIsUploadingPopupVisible(true);
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      console.log("progressEvent.total", progressEvent.total);
      console.log("progressEvent.loaded", progressEvent.loaded);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 30) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 70) {
          status = t("OCR_MODAL_ALMOST_THERE_MSG");
          description = t("OCR_MODAL_RIGHT_PLACE_MSG");
        } else if (percentCompleted < 100) {
          status =  t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        } else {
          status =  t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        }

        return {
          progress: percentCompleted,
          status,
          description,
          started: true,
        };
      });
    },
  };

  const uploadToOCR = async () => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";

    const parserKey =
      ownerType === "IndividualOwner"
        ? "driver"
        : ownerType === "FleetTruck"
        ? "truck"
        : "fleet";

    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", "Truck");
    form.append("countryCode", String(user?.countryCode || ""));
    form.append("entityType", EntityTypes.TRUCK);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      console.log("OCR Upload Response:", response);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId((prev) =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      if (typeof message === "object") {
        message = message?.description || JSON.stringify(message);
      }
      Notification.error("Upload Failed", message);
    }
  };

  const checkTruckExistenceOnOCRUpload = async (plateNumber, supplierId) => {
    const payload = {
      assetPlateNumber: plateNumber,
      supplierId: supplierId || "",
    };

    try {
      const response = await truckService.CheckTruckExist(payload);

      if (response.status === 200) {
        const truckData = response?.data?.data;

        if (truckData?.isTruckExist) {
          return {
            exists: true,
            truckData,
          };
        } else {
          return {
            exists: false,
            truckData: null,
          };
        }
      }
    } catch (error) {
      console.error("CheckTruckExist failed", error);
      return {
        exists: false,
        truckData: null,
        error: true,
      };
    }
  };

  const isOcrDataValid = (ocrParsedData) => {
    console.log("isOcrDataValid before", ocrParsedData);
    console.log("isOcrDataValid before ocrParsedData", !ocrParsedData);
    console.log(
      "isOcrDataValid before !ocrParsedData?.documents",
      !ocrParsedData?.documents
    );
    debugger;
    if (!ocrParsedData || !ocrParsedData?.documents) {
      return false;
    }

    return ocrParsedData.documents.every((doc) => {
      console.log(
        "isOcrDataValid return values",
        doc.status,
        Array.isArray(doc.errors),
        doc.errors?.length === 0
      );

      return (
        doc.status === true &&
        Array.isArray(doc.errors) &&
        doc.errors?.length === 0
      );
    });
  };

  // **** Before -- Submit to upload DOC to OCR Only
  // const onClickSubmit = async () => {
  //   setIsUploadingPopupVisible(true);
  //   // await uploadToOCR();
  //   const parsedData = await uploadToOCR();

  //   setIsUploadingPopupVisible(false);
  //   setUploadState(initialUploadState);
  //   // Check for OCR data Has No Errors
  //   if (isOcrDataValid(parsedData)) {

  //     // setIsOcrFileUpload(false);
  //     // setNextBtn(true);
  //     const result = await checkTruckExistenceOnOCRUpload(ocrPlateNumber, supplierId || "");

  //     if (result?.error) {
  //       console.error("Truck existence check failed");
  //       return;
  //     }

  //     if (result.exists) {
  //       setTruckId(result.truckData);
  //       setTruckExist(true);
  //     } else {
  //       setIsOcrFileUpload(false);
  //       setNextBtn(true);
  //       setShowPlateMismatchModal(false);
  //     }

  //   } else {
  //     console.warn(
  //       "Validation failed: Some documents have errors or status is false."
  //     );
  //   }
  // };
  // ****** After -- add Missing modal to submit Button
  const onClickSubmit = async () => {
    if (ocrParsedData && !isOcrDataValid(ocrParsedData)) {
      setMissingDocModal(true);
      return;
    }

    setIsUploadingPopupVisible(true);
    const parsedData = await uploadToOCR();
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);

    // Check for OCR data has no errors
    if (isOcrDataValid(parsedData)) {
      const result = await checkTruckExistenceOnOCRUpload(
        ocrPlateNumber,
        supplierId || ""
      );

      if (result?.error) {
        console.error("Truck existence check failed");
        return;
      }

      if (result.exists) {
        setTruckId(result.truckData);
        setTruckExist(true);
      } else {
        setIsOcrFileUpload(false);
        setNextBtn(true);
        setShowPlateMismatchModal(false);
      }
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  const handleDrawerFileSubmit = async () => {
    setIsUploadingPopupVisible(true);
    // await uploadToOCR();
    const parsedData = await uploadToOCR();
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);
    if (isOcrDataValid(parsedData)) {
      // setCurrentStep(SignUpSteps.BASIC_INFO);
      setIsOcrFileUpload(false);
      setNextBtn(true);
      setOpenDrawer(false);
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  console.log("ocrParsedData", ocrParsedData);
  const onSkipSectionChange = async () => {
    if (!ocrParsedData) {
      if (ocrConfirmedFiles.length > 0) {
        // Notification.warning(
        //   "Files Not Submitted",
        //   "No files were uploaded. Proceeding to the next step."
        // );
        // setMissingDocModal(true);
        setIsDiscardModalVisible(true);
      } else {
        setNextBtn(true);
        setIsOcrFileUpload(false);
      }
    } else {
      // Parsed data exists — show modal for missing documents
      // ***** Before Checking ******
      // setMissingDocModal(true);
      setIsDiscardModalVisible(true);

      // **** NEW Check for before skipping to next step ***
      // if (isOcrDataValid(ocrParsedData)) {
      //   debugger
      //   // setNextBtn(true);
      //   // setIsOcrFileUpload(false);
      //   const result = await checkTruckExistenceOnOCRUpload(ocrPlateNumber, supplierId || "");

      //   if (result?.error) {
      //     console.error("Truck existence check failed");
      //     return;
      //   }

      //   if (result.exists) {
      //     setTruckId(result.truckData);
      //     setTruckExist(true);
      //   } else {
      //     setFormValues((prev) => ({
      //       ...prev,
      //       assetPlateNumber: ocrPlateNumber,
      //       truckRegistrationNo: ocrPlateNumber,
      //     }));
      //     addTruckForm.setFieldsValue({
      //       assetPlateNumber: ocrPlateNumber,
      //       truckRegistrationNo: ocrPlateNumber,
      //     });
      //     setShowPlateMismatchModal(false);
      //     setIsOcrFileUpload(false);
      //     setNextBtn(true);
      //     setShowPlateMismatchModal(false);
      //     }

      // } else {
      //   debugger
      // setMissingDocModal(true);
      // }
    }
  };

  const handleProceedDiscardOcrData = () => {
    setIsDiscardModalVisible(false);
    setMissingDocModal(false);
    setNextBtn(true);

    // Reset OCR-related states
    setUploadedFileData([]);
    setOcrConfirmedFiles([]);
    setOcrParsedData(null);
    setOcrLogId("");
    setUploadState(initialUploadState);
  };

  // const useOcrPlateHandler = ()=>{
  //   const payload = {
  //   assetPlateNumber: ocrPlateNumber,
  //   supplierId: supplierId ? supplierId : "",
  //   };

  //   truckService
  //   .CheckTruckExist(payload)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         if (response?.data?.data?.isTruckExist) {
  //           setBtnLoader(false);
  //           setTruckId(response?.data?.data);
  //           setTruckExist(true);
  //         } else if (!response?.data?.data?.isTruckExist) {
  //         setBtnLoader(false);
  //         // setNextBtn(true);
  //         // setIsOcrFileUpload(false);
  //         setFormValues((prev) => ({
  //         ...prev,
  //         assetPlateNumber: ocrPlateNumber,
  //         truckRegistrationNo: ocrPlateNumber,
  //         }));
  //         addTruckForm.setFieldsValue({
  //         assetPlateNumber: ocrPlateNumber,
  //         truckRegistrationNo: ocrPlateNumber,
  //         });
  //         setShowPlateMismatchModal(false);
  //         }
  //       }
  //     })
  //   .catch((err) => {
  //   setBtnLoader(false);
  //   // onClose();
  //   });

  // }

  const useOcrPlateHandler = async () => {
    setBtnLoader(true);

    const result = await checkTruckExistenceOnOCRUpload(
      ocrPlateNumber,
      supplierId || ""
    );

    setBtnLoader(false);

    if (result?.error) {
      console.error("Truck existence check failed");
      return;
    }

    if (result.exists) {
      setTruckId(result.truckData);
      setTruckExist(true);
      setShowPlateMismatchModal(false);
    } else {
      setFormValues((prev) => ({
        ...prev,
        assetPlateNumber: ocrPlateNumber,
        truckRegistrationNo: ocrPlateNumber,
      }));
      addTruckForm.setFieldsValue({
        assetPlateNumber: ocrPlateNumber,
        truckRegistrationNo: ocrPlateNumber,
      });
      setShowPlateMismatchModal(false);
    }
  };

  // ****************** OCR EDIT  *****************
  const OCRFieldNames = {
    TRUCK_RC: "TRUCK_RC",
    TRAILER_RC: "TRAILER_RC",
  };

  //******* */ upload directly to CLOUD *********
  const uploadDirectToCloud = async (
    fileWrapper,
    fieldName,
    ocrFieldName,
    fileType
  ) => {
    const actualFile = fileWrapper.file ?? fileWrapper;

    const form = new FormData();
    form.append("file", actualFile);

    const payload = {
      docType: fileType,
      entityType: EntityTypes.TRUCK,
      fileName: actualFile.name,
      docName: actualFile.name ? actualFile.name.replace(/\s+/g, "_") : "",
      fileData: "",
      fileURL: "",
      fileThumbURL: "",
      fileThumbName: "",
      uniqueID: "",
      totalPartition: 1,
      seq: 1,
      isPathSet: true,
    };

    form.append("details", JSON.stringify(payload));

    try {
      const response = await uploadDocumentV2(form, config);
      if (response.data.status === 200) {
        const data = response.data.data;
        console.log("uploadDocumentV2 data", data);

        // decide whether it's a backDoc upload

        const isBackDoc =
          fieldName?.toLowerCase().includes("back") &&
          (ocrFieldName === OCRFieldNames.TRUCK_RC ||
            ocrFieldName === OCRFieldNames.TRAILER_RC);

        setFormValues((prev) => ({
          ...prev,
          [fieldName]: {
            ...prev?.[fieldName],
            FileName: data.fileName || "",
            FileThumbName: data.fileThumbName || "",
            FileURL: data.fileURL || "",
            FileThumbURL: data.fileThumbURL || "",
            isPathSet: true,
            isInsertUpdate: true,
            isOCRDoc: false,
          },
        }));

        const normalizedFile = {
          docType: data.docType,
          EntityId: data.entityId,
          FileName: data.fileName,
          FileThumbName: data.fileThumbName,
          FileThumbURL: data.fileThumbURL,
          FileURL: data.fileURL,
          Status: data.status ?? false,
        };

        console.log("normalizedFile", normalizedFile);

        onFileUploadDocs(normalizedFile, fieldName);

        Notification.success(t("SUCCESS_KEY"), t("FILE_UPLOADED_SUCCESS"));
      } else {
        Notification.error(response.data.message || "Upload failed");
      }
    } catch (error) {
      console.error("uploadDirectToJCloud error", error);
      Notification.error(t("ERROR_MESSAGE"));
    }
  };

  const ocrMappedData = (ocrFieldName, doc) => {
    console.log("ocrMappedData doc", doc);
    console.log("ocrMappedData ocrFieldName", doc);
    switch (ocrFieldName) {
      case "TRUCK_RC": {
        const { docNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedTruckExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        // nextBtnTwo fieldValues Set
        const brandName = doc?.truckBrandName || null;
        const numberPlateIssuer = doc?.truckOwner || null;
        const manufacturingYear = doc?.truckManufacturingYear
          ? dayjs(doc.truckManufacturingYear, "YYYY").format("YYYY")
          : null;

        const truckRegFront = {
          EntityId: "Truck",
          FileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          FileURL: frontUrl || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const truckRegBack = {
          EntityId: "Truck",
          FileName: `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            backUrl
          )}`,
          FileThumbName: `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
            backUrl
          )}`,
          FileURL: backUrl || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(backUrl) || null,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          truckRegExpiry: parsedTruckExpiry,
          truckRegFront,
          truckRegBack,
          brandName,
          numberPlateIssuer,
          manufacturingYear,
        }));
        setTruckChassisNumber(doc?.truckChassisNumber ?? "")
        setTruckModel(doc?.truckModel ?? "")
        setPlateSequenceNumber(doc?.plateSequenceNumber ?? "")
        setMotorNumber(doc?.motorNumber ?? "")
        addTruckForm.setFieldsValue({
          truckRegExpiry: parsedTruckExpiry,
          truckRegFront,
          truckRegBack,
          brandName,
          numberPlateIssuer,
          manufacturingYear,
        });
        break;
      }
      case "TRAILER_RC": {
        const { truckPlateNumber, docExpiryDate, frontUrl, backUrl } = doc;
        const parsedtrailerExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const trailerDocFront = {
          EntityId: "Truck",
          FileName: `ActualTruck/${ocrLogId}_TRAFD$${documentUtility.getFileExtension(
            frontUrl
          )}`,
          FileThumbName: `ActualTruck_Thumb/${ocrLogId}_TRAFD${documentUtility.getFileExtension(
            frontUrl
          )}`,
          FileURL: frontUrl || null,
          FileUrl: frontUrl || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(frontUrl) || null,
          FileThumbUrl: documentUtility.getThumbnailImagePath(frontUrl) || null,
          Status: false,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };
        const trailerDocBack = {
          EntityId: "Truck",
          FileName: `ActualTruck/${ocrLogId}_TRABD${documentUtility.getFileExtension(
            backUrl
          )}`,
          FileThumbName: `ActualTruck_Thumb/${ocrLogId}_TRABD${documentUtility.getFileExtension(
            backUrl
          )}`,
          FileURL: backUrl || null,
          FileUrl: backUrl || null,
          FileThumbURL: documentUtility.getThumbnailImagePath(backUrl) || null,
          FileThumbUrl: documentUtility.getThumbnailImagePath(backUrl) || null,
          Status: false,
          isPathSet: true,
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setChecked(true);

        setFormValues((prev) => ({
          ...prev,
          trailerRegistrationNo: truckPlateNumber,
          trailerExpiry: parsedtrailerExpiry,
          trailerDocFront,
          trailerDocBack,
        }));

        addTruckForm.setFieldsValue({
          trailerRegistrationNo: truckPlateNumber,
          trailerExpiry: parsedtrailerExpiry,
          trailerDocFront,
          trailerDocBack,
        });
        break;
      }

      default: {
        console.warn(
          `No mapping found in ocrMappedData for docType: ${ocrFieldName}`,
          doc
        );

        break;
      }
    }
  };

  const uploadEditToOCR = async (ocrConfirmedFiles) => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };

    const parserKey =
      ownerType === "IndividualOwner"
        ? "driver"
        : ownerType === "FleetTruck"
        ? "truck"
        : "fleet";

    const parserApp = parserAppMap[parserKey] || "";

    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", "Truck");
    form.append("countryCode", String(user?.countryCode || ""));
    form.append("entityType", EntityTypes.TRUCK);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId((prev) =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      Notification.error("Upload Failed", message);
    }
  };

  const handleEditOCRConformFileChange = async (
    newFiles,
    fieldName,
    ocrFieldName,
    fileType
  ) => {
    if (!newFiles || newFiles.length === 0) return;

    console.log("handleEditOCRConformFileChange newFiles", newFiles[0]);
    console.log("handleEditOCRConformFileChange fieldName", fieldName);

    setUploadState(initialUploadState);
    setIsUploadingPopupVisible(true);

    let responseParseData = null;
    try {
      // Calling the OCR API function to fetch OCR data
      responseParseData = await uploadEditToOCR(newFiles);
    } catch (error) {
      console.error("OCR failed, will fallback to direct upload", error);
    }

    // IF Data is From OCR and Data is Correct as per ocrFieldName
    if (responseParseData?.documents?.length) {
      const documents = responseParseData.documents;
      console.log("responseParseData.documents", documents);
      const matchedDoc = documents.find(
        (doc) => doc.docType === ocrFieldName && doc.status === true
      );
      console.log("matchedDoc", matchedDoc);

      if (matchedDoc) {
        ocrMappedData(ocrFieldName, matchedDoc);
        debugger;
        setIsUploadingPopupVisible(false);
        return;
      }
    }

    //  OCR failed or didn’t match → direct upload to Cloud
    try {
      debugger;
      await uploadDirectToCloud(newFiles[0], fieldName, ocrFieldName, fileType);
    } catch (err) {
      console.error("Direct upload failed too:", err);
    } finally {
      setIsUploadingPopupVisible(false); // close popup after cloud upload
    }
  };

  const handleEditingDeleteFile = (fieldName, ocrFieldName) => {
    console.log("handleEditingDeleteFile", fieldName);

    setFormValues((prev) => {
      const updated = { ...prev };

      if (["truckRegBack", "trailerDocBack"].includes(fieldName)) {
        updated[fieldName] = {
          ...prev?.[fieldName],
          FileName: "",
          FileThumbName: "",
          FileURL: "",
          FileThumbURL: "",
          isPathSet: false,
          isInsertUpdate: false,
          isOCRDoc: false,
        };
      } else {
        updated[fieldName] = {
          ...prev?.[fieldName],
          FileName: "",
          FileThumbName: "",
          FileURL: "",
          FileThumbURL: "",
          isPathSet: false,
          isInsertUpdate: false,
          isOCRDoc: false,
        };
      }

      return updated;
    });
  };

  if (!isOpen) return null;

  return (
    <>
      <Modal
        open={isOpen}
        centered
        maskClosable={false}
        onCancel={() => {
          setNextBtn(false);
          onClose();
        }}
        width={addFleet ? "70rem" : "33rem"}
        title={
          <div>
            {formType === "editForm"
              ? t("EDIT_TRUCK_KEY")
              : truckExist
              ? t("TRUCK_NO_EXIST_KEY")
              : t("ADD_NEW_TRUCK_KEY")}{" "}
            <span className="title-span">{/* (step {nextBtn?2:1}/2) */}</span>
          </div>
        }
        footer={false}
      >
        <div style={{}} className="add-modal-form">
          <Divider />
          {!truckExist || formType === "editForm" ? (
            <Form
              name="addTruckForm"
              layout="vertical"
              form={addTruckForm}
              className="ant-form"
            >
              {nextBtnTwo ? (
                <div className="truck-form-items">
                  <div className="other-details">
                    {t("OTHER_DETAILS_COMMON")}:
                  </div>

                  <Form.Item
                    name="brandName"
                    className="floating-label-form-item"
                    //   rules={[{ required: true, message: 'Please enter brand name' }]}
                  >
                    <Select
                      value={formValues?.brandName}
                      showSearch
                      filterOption={(input, option) =>
                        option?.make_name
                          ?.toLowerCase()
                          .indexOf(input?.toLowerCase()) >= 0
                      }
                      options={brandName}
                      loading={isBrandNameWaiter}
                      size="small"
                      className="floating-selectt-truck"
                      fieldNames={{ label: "make_name", value: "make_name" }}
                      placeholder={t("BRAND_NAME_PLACEHOLDER")}
                      onChange={(val, option) => {
                        addTruckForm.setFieldsValue({ brandName: val });
                        // handleFormChange(val, option);
                        handleFormChange("brandName", val);
                      }}
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_BRAND_NAME")}
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="numberPlateIssuer"
                    rules={[
                      {
                        // validator: validateNotEmpty("number plate issuer name"),
                        // Special characters are allowed here; only an
                        // all-whitespace value is rejected.
                        validator: validateNotOnlySpaces(
                          "number plate issuer name"
                        ),
                      },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Input
                      value={formValues.numberPlateIssuer}
                      style={{ width: "100%" }}
                      className="floating-input"
                      placeholder={t("PLATE_NO_ISSUER_PLACEHOLDER")}
                      onChange={(e) =>
                        handleFormChange("numberPlateIssuer", e.target.value)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_NO_PLATE_ISSUER_NAME")}
                    </label>
                  </Form.Item>

                  <Form.Item
                    // name='manufacturingYear'
                    className="floating-label-form-item"
                    rules={[
                      { validator: validateNotEmpty("manufacturing year") },
                    ]}
                  >
                    <DatePicker
                      className="floating-selectt-truck"
                      onChange={(date, yearString) =>
                        handleFormChange("manufacturingYear", yearString)
                      }
                      picker="year"
                      disabledDate={disabledDate}
                      value={
                        formValues.manufacturingYear
                          ? dayjs(
                              formValues.manufacturingYear.toString(),
                              "YYYY"
                            )
                          : null
                      }
                      format="YYYY"
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_MANUFACTURING_YEAR")}
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="registrationCountry"
                    // rules={[{ required: true, message: 'Please Enter Registration Country!' }]}
                    className="floating-label-form-item"
                  >
                    <Select
                      value={formValues.registrationCountry}
                      className="floating-selectt-truck"
                      options={countryOptions}
                      showSearch
                      placeholder={t("REGISTRATION_COUNTRY_PLACEHOLDER")}
                      fieldNames={{ label: "name", value: "name" }}
                      onChange={(value, option) => {
                        addTruckForm.setFieldValue(
                          "registrationCountry",
                          value
                        );
                        addTruckForm.setFieldValue(
                          "registrationCountryCode",
                          option.country_code
                        );
                        setFormValues((prev) => ({
                          ...prev,
                          registrationCountry: value,
                          registrationCountryCode: option.country_code,
                          registrationCity: undefined,
                        }));
                        addTruckForm.validateFields(["registrationCountry"]);

                        setCityOptions([]);
                        const countryFilter = countryOptions.find(
                          (item) => item.name === value
                        );
                        getCityList(countryFilter?.country_code);
                      }}
                      loading={countriesListWaiter}
                      filterOption={(input, option) =>
                        option.name
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_REG_COUNTRY")}
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="registrationCity"
                    className="floating-label-form-item"
                  >
                    <Select
                      value={formValues.registrationCity}
                      className="floating-selectt-truck"
                      placeholder={t("REGISTRATION_CITY_PLACEHOLDER")}
                      showSearch
                      options={cityOptions}
                      fieldNames={{
                        label: "name",
                        value: "name",
                      }}
                      loading={cityOptionsWaiter}
                      onChange={(val) => {
                        addTruckForm.setFieldsValue({ city: val });
                        handleFormChange("registrationCity", val);
                      }}
                      filterOption={(input, option) =>
                        option.name
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_REGISTRATION_CITY")}
                    </label>
                  </Form.Item>
                </div>
              ) : isOcrFileUpload ? (
                // ************** OCRUPload Screen *****************
                <>
                  <div className="ocr-file-upload-block">
                    {ocrConfirmedFiles.length === 0 ? (
                      <AutofillDocUpload
                        onFileUpload={handleFileChange}
                        filetype={frontDocs}
                        multipleUploadedFilesData={uploadedFileData}
                        onFileDelete={handleFileDelete}
                        onViewSample={handleViewSampleClick}
                        ownerType={ownerType}
                      />
                    ) : (
                      <DocumentListView
                        documentData={ocrConfirmedFiles}
                        onDelete={handleOCRConfirmFileDelete}
                        openUploadDrawer={() => setOpenDrawer(true)}
                        ocrParsedDataDocuments={ocrParsedData?.documents || []}
                      />
                    )}
                  </div>
                </>
              ) : nextBtn ? (
                // ************** ADD NEW TRUCK BASIC INFO *****************
                <div
                  className={
                    checked ? "truck-form-scroll" : "truck-form-container"
                  }
                >
                  <span>{t("FLEET_TRUCKS_REG_CERTIFICATE")} *</span>
                  <Row gutter={16}>
                    <Col span={12}>
                      <label>{t("FRONT_SIDE_DOCUMENT")}</label>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="truckRegFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("TRUCK_REGISTRATION_FRONT_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.TRUCK_FRONT}
                            defaultThumbFile={documentUtility.getThumbnailImagePath(
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            )}
                            defaultFile={
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileName
                                : frontDocs?.fileName
                            }
                            entityId=""
                            entityType={EntityTypes.TRUCK}
                            accessFile={false}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "truckRegFront");
                            }}
                            // updateFormValue={(val)=>{ addTruckForm.setFieldValue({ truckRegFront: val })}}
                          />
                        </Form.Item>
                      )}

                      {/* ****truckRegFront  OCR File Registration Certificate ****** */}
                      {formType === "editForm" && (
                        <Form.Item
                          name="truckRegFront"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("TRUCK_REGISTRATION_FRONT_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.TRUCK_FRONT}
                            defaultThumbFile={documentUtility.getThumbnailImagePath(
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            )}
                            defaultFile={
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.truckRegFront
                                ? formValues?.truckRegFront?.FileName
                                : frontDocs?.fileName
                            }
                            entityId=""
                            entityType={EntityTypes.TRUCK}
                            accessFile={false}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "truckRegFront",
                                OCRFieldNames.TRUCK_RC,
                                DocTypes.TRUCK_FRONT
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "truckRegFront",
                                OCRFieldNames.TRUCK_RC
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      <label>{t("BACK_SIDE_DOCUMENT")}</label>
                      {formType !== "editForm" && (
                        <Form.Item
                          name="truckRegBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("TRUCK_REGISTRATION_BACK_REQUIRED"),
                            },
                          ]}
                        >
                          <Fileupload
                            filetype={DocTypes.TRUCK_BACK}
                            defaultThumbFile={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileName
                                : frontDocs?.fileName
                            }
                            entityId=""
                            entityType={EntityTypes.TRUCK}
                            accessFile={false}
                            name={t("KYC_UPLOAD_BACK_LBL")}
                            onChange={(value) => {
                              onFileUploadDocs(value, "truckRegBack");
                              // addTruckForm.setFieldValue({ truckRegBack: value });
                            }}
                            // updateFormValue={(val)=>{ addTruckForm.setFieldValue({ truckRegBack: val })}}
                          />
                        </Form.Item>
                      )}
                      {/* ****truckRegBack  OCR File Registration Certificate ****** */}
                      {formType === "editForm" && (
                        <Form.Item
                          name="truckRegBack"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("TRUCK_REGISTRATION_BACK_REQUIRED"),
                            },
                          ]}
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // if your component emits [ { file, fileThumbUrl } ]
                            if (Array.isArray(e) && e.length > 0) {
                              return {
                                // File: e[0].file,
                                // FileThumbURL: e[0].fileThumbUrl,
                              };
                            }
                            return e;
                          }}
                        >
                          <OCRFilePreviewUploader
                            filetype={DocTypes.TRUCK_BACK}
                            defaultThumbFile={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileThumbURL
                                : frontDocs?.FileThumbURL
                            }
                            defaultFile={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileURL
                                : frontDocs?.FileURL
                            }
                            fileName={
                              formValues?.truckRegBack
                                ? formValues?.truckRegBack?.FileName
                                : frontDocs?.fileName
                            }
                            entityId=""
                            entityType={EntityTypes.TRUCK}
                            accessFile={false}
                            // onChange={(value) => {
                            //   onFileUploadDocs(value, "vatUpload");
                            // }}
                            name={t("KYC_UPLOAD_FRONT_LBL")}
                            onChange={(newFiles) =>
                              handleEditOCRConformFileChange(
                                newFiles,
                                "truckRegBack",
                                OCRFieldNames.TRUCK_RC,
                                DocTypes.TRUCK_BACK
                              )
                            }
                            onDelete={() =>
                              handleEditingDeleteFile(
                                "truckRegBack",
                                OCRFieldNames.TRUCK_RC
                              )
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                  <Form.Item
                    name="truckRegistrationNo"
                    // rules={[{ required: true, message: 'Please enter your truck registration number!' },
                    //     { validator: validateNotEmpty('truck registration number') }
                    // ]}
                    className="floating-label-form-item"
                  >
                    {" "}
                    {addTruckForm.setFieldsValue({
                      truckRegistrationNo: formValues?.assetPlateNumber,
                    })}
                    <Input
                      disabled={true}
                      maxLength={20}
                      value={formValues?.assetPlateNumber}
                      style={{ width: "100%" }}
                      className="floating-input"
                      placeholder={t("TRUCK_REGISTRATION_PLACEHOLDER")}
                      onChange={(e) =>
                        handleFormChange(
                          "truckRegistrationNo",
                          formValues?.assetPlateNumber
                        )
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_REGISTRATION_NO")}
                      <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="truckRegExpiry"
                    rules={[
                      { required: true, message: t("EXPIRY_DATE_REQUIRED") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <DatePicker
                      className="floating-input"
                      format={dateFormat}
                      placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                      disabledDate={disablePastDates}
                      value={
                        formValues?.truckRegExpiry
                          ? dayjs(formValues.truckRegExpiry, dateFormat)
                          : null
                      }
                      onChange={(date, dateString) =>
                        handleFormChange("truckRegExpiry", dateString)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_EXPIRY_DATE")} <span>*</span>
                    </label>
                  </Form.Item>
                  {/* <p>Trailer Documentation</p> */}
                  <Checkbox
                    checked={checked}
                    onChange={(e) => {
                      setChecked(e.target.checked);
                    }}
                  >
                    {t("FLEET_TRUCKS_TRAILER_DOC")}
                  </Checkbox>
                  {checked && (
                    <>
                      <Row gutter={16}>
                        <Col span={12}>
                          {formType !== "editForm" && (
                            <Form.Item
                              name="trailerDocFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("TRAILER_DOC_FRONT_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.TRUCK_TRAILER_FRONT}
                                defaultThumbFile={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileName
                                    : frontDocs?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.TRUCK}
                                accessFile={false}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "trailerDocFront");
                                  // addTruckForm.setFieldValue({ trailerDocFront: value });
                                }}
                                // updateFormValue={(val)=>{ addTruckForm.setFieldValue({ trailerDocFront: val })}}
                              />
                            </Form.Item>
                          )}

                          {formType === "editForm" && (
                            <Form.Item
                              name="trailerDocFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("TRAILER_DOC_FRONT_REQUIRED"),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              <OCRFilePreviewUploader
                                filetype={DocTypes.TRUCK_TRAILER_FRONT}
                                defaultThumbFile={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.trailerDocFront
                                    ? formValues?.trailerDocFront?.FileName
                                    : frontDocs?.fileName
                                }
                                entityType={EntityTypes.TRUCK}
                                accessFile={false}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                // onChange={(value) => {
                                //   onFileUploadDocs(value, "vatUpload");
                                // }}
                                onChange={(newFiles) =>
                                  handleEditOCRConformFileChange(
                                    newFiles,
                                    "trailerDocFront",
                                    OCRFieldNames.TRAILER_RC,
                                    DocTypes.TRUCK_TRAILER_FRONT
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "trailerDocFront",
                                    OCRFieldNames.TRAILER_RC
                                  )
                                }
                              />
                            </Form.Item>
                          )}
                        </Col>
                        <Col span={12}>
                          {formType !== "editForm" && (
                            <Form.Item
                              name="trailerDocBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("TRAILER_DOC_BACK_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.TRUCK_TRAILER_BACK}
                                defaultThumbFile={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileName
                                    : frontDocs?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.TRUCK}
                                accessFile={false}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "trailerDocBack");
                                  // addTruckForm.setFieldValue({ trailerDocBack: value });
                                }}
                                // updateFormValue={(val)=>{ addTruckForm.setFieldValue({ trailerDocBack: val })}}
                              />
                            </Form.Item>
                          )}

                          {formType === "editForm" && (
                            <Form.Item
                              name="trailerDocBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("TRAILER_DOC_BACK_REQUIRED"),
                                },
                              ]}
                              valuePropName="value"
                              getValueFromEvent={(e) => {
                                // if your component emits [ { file, fileThumbUrl } ]
                                if (Array.isArray(e) && e.length > 0) {
                                  return {
                                    // File: e[0].file,
                                    // FileThumbURL: e[0].fileThumbUrl,
                                  };
                                }
                                return e;
                              }}
                            >
                              <OCRFilePreviewUploader
                                filetype={DocTypes.TRUCK_TRAILER_BACK}
                                defaultThumbFile={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileThumbURL
                                    : frontDocs?.FileThumbURL
                                }
                                defaultFile={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileURL
                                    : frontDocs?.FileURL
                                }
                                fileName={
                                  formValues?.trailerDocBack
                                    ? formValues?.trailerDocBack?.FileName
                                    : frontDocs?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.TRUCK}
                                accessFile={false}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                // onChange={(value) => {
                                //   onFileUploadDocs(value, "vatUpload");
                                // }}

                                onChange={(newFiles) =>
                                  handleEditOCRConformFileChange(
                                    newFiles,
                                    "trailerDocBack",
                                    OCRFieldNames.TRAILER_RC,
                                    DocTypes.TRUCK_TRAILER_BACK
                                  )
                                }
                                onDelete={() =>
                                  handleEditingDeleteFile(
                                    "trailerDocBack",
                                    OCRFieldNames.TRAILER_RC
                                  )
                                }
                              />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Form.Item
                        name="trailerRegistrationNo"
                        rules={[
                          {
                            required: true,
                            message: t("TRAILER_REGISTRATION_NO_REQUIRED"),
                          },
                          {
                            validator: validateNotEmpty(
                              "trailer registration number"
                            ),
                          },
                        ]}
                        className="floating-label-form-item"
                      >
                        <Input
                          value={formValues?.trailerRegistrationNo}
                          style={{ width: "100%" }}
                          className="floating-input"
                          placeholder={t("TRAILER_REG_NO_PLACEHOLDER")}
                          onChange={(e) =>
                            handleFormChange(
                              "trailerRegistrationNo",
                              e.target.value
                            )
                          }
                        />
                        <label className="floating-label">
                          {t("FLEET_TRUCKS_REGISTRATION_NO")} <span>*</span>
                        </label>
                      </Form.Item>
                      <Form.Item
                        name="trailerExpiry"
                        rules={[
                          {
                            required: true,
                            message: t("EXPIRY_DATE_REQUIRED"),
                          },
                        ]}
                        className="floating-label-form-item"
                      >
                        <DatePicker
                          className="floating-input"
                          format={dateFormat}
                          placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                          disabledDate={disablePastDates}
                          value={
                            formValues?.trailerExpiry
                              ? dayjs(formValues.trailerExpiry, dateFormat)
                              : null
                          }
                          onChange={(date, dateString) =>
                            handleFormChange("trailerExpiry", dateString)
                          }
                        />
                        <label className="floating-label">
                          {t("FLEET_TRUCKS_EXPIRY_DATE")} <span>*</span>
                        </label>
                      </Form.Item>
                    </>
                  )}
                </div>
              ) : (
                // *************** ADD NEW TRUCK STEP-1 *******************
                <div className="truck-form-items">
                  {/* {formValues?.truckType &&  */}
                  <div className="truck-image">
                    {truckTypeOptions.find(
                      (item) => item.type_id === formValues?.truckType
                    ) && (
                      <img
                        src={
                          formValues?.truckType
                            ? truckTypeOptions.find(
                                (item) => item.type_id === formValues?.truckType
                              )?.truckImage
                            : ""
                        }
                        alt=""
                      />
                    )}
                  </div>
                  {/* } */}
                  <Form.Item
                    name="assetPlateNumber"
                    rules={[
                      { required: true, message: t("ASSET_PLATE_NO_REQUIRED") },
                      { validator: validateNotEmpty("asset plate number") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Input
                      value={formValues?.assetPlateNumber}
                      style={{ width: "100%" }}
                      maxLength={20}
                      className="floating-input"
                      placeholder={t("PLATE_NO_PLACEHOLDER")}
                      onChange={(e) =>
                        handleFormChange("assetPlateNumber", e.target.value)
                      }
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCK_ASSET_PLATE_NO")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="truckType"
                    rules={[
                      { required: true, message: t("TRUCK_TYPE_REQUIRED") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Select
                      value={formValues?.truckType}
                      className="floating-selectt-truck"
                      placeholder={t("TRUCK_TYPE_PLACEHOLDER")}
                      // options={truckTypeOptions}
                      loading={truckTypeWaiter}
                      // fieldNames={{
                      //     label: "type",
                      //     value: "type_id",
                      // }}
                      name="truckType"
                      onChange={(value) => {
                        setSubTruckTypeOptions([]);
                        setFormValues((prev) => ({
                          ...prev,
                          subTruckType: undefined,
                        }));
                        addTruckForm.setFieldValue("subTruckType", undefined);
                        handleFormChange("truckType", value);
                        getSubTruckType(value);
                      }}
                    >
                      {truckTypeOptions?.map((item) => (
                        <Option key={item.type_id} value={item.type_id}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              borderBottom:
                                !formValues?.truckType && "1px solid #D3D3D3",
                              padding: "8px 0",
                            }}
                          >
                            <span>{item.type}</span>
                            <img
                              src={item.truckImage}
                              alt={item.type}
                              style={{ width: 100, height: 30 }}
                            />
                          </div>
                        </Option>
                      ))}
                    </Select>
                    <label className="floating-label">
                      {t("FLEET_TRUCKS_TRUCK_TYPE")} <span>*</span>
                    </label>
                  </Form.Item>
                  <Form.Item
                    name="subTruckType"
                    rules={[
                      { required: true, message: t("SUB_TRUCK_TYPE_REQUIRED") },
                    ]}
                    className="floating-label-form-item"
                  >
                    <Select
                      value={formValues?.subTruckType}
                      className="floating-selectt-truck"
                      placeholder={t("TRUCK_SUB_TYPE_PLACEHOLDER")}
                      options={subTruckTypeOptions}
                      loading={subTruckTypeWaiter}
                      name="subTruckType"
                      onChange={(value, option) => {
                        setWeight(option?.weight);
                        setWeightUnits(option?.unit);
                        handleFormChange("subTruckType", value);
                      }}
                    />
                    <label className="floating-label">
                      {t("FLEET_TRUCK_SUB_TYPE")} <span>*</span>
                    </label>
                  </Form.Item>
                </div>
              )}
              {/* ******************  Normal flow Buttons ****************** */}
              {!isOcrFileUpload && (
                <Form.Item className="btn-line">
                  <Button
                    type="secondary"
                    className="cancel-btn"
                    onClick={() => {
                      // Keep whatever is on screen when stepping backwards
                      const currentValues = addTruckForm.getFieldsValue();

                      // Other details -> registration details.
                      // Same step order in both the add and edit flows.
                      if (nextBtnTwo) {
                        setFormValues((prev) => ({
                          ...prev,
                          ...currentValues,
                        }));
                        setNextBtnTwo(false);
                        setNextBtn(true);
                        return;
                      }

                      // Edit starts on the registration details step, so there
                      // is nothing before it to go back to
                      if (formType === "editForm") {
                        onClose();
                        return;
                      }

                      // Registration details -> document upload, so the user
                      // can change the documents they uploaded
                      if (nextBtn) {
                        setFormValues((prev) => ({
                          ...prev,
                          ...currentValues,
                        }));
                        setNextBtn(false);
                        setIsOcrFileUpload(true);
                        return;
                      }

                      setWarningModal(true);
                    }}
                  >
                    {nextBtnTwo || (formType !== "editForm" && nextBtn)
                      ? t("BACK_KEY")
                      : t("COMMON_CANCEL_BTN")}
                    {/* {'Skip'} */}
                  </Button>
                  <Button
                    type="secondary"
                    loading={btnLoader}
                    className="submit-btn"
                    onClick={onSubmitHandler}
                  >
                    {formType === "editForm" && nextBtnTwo
                      ? t("COMMON_SAVE_BTN")
                      : nextBtnTwo
                      ? t("ADD_TRUCK_KEY")
                      : t("NEXT_KEY")}
                  </Button>
                </Form.Item>
              )}
              {/* ***************** Skip Porceed and Submit button for OCRUpload ************* */}
              {isOcrFileUpload && (
                <Row
                  justify="center"
                  gutter={8}
                  style={{
                    width: "100%",
                    bottom: 0,
                    position: "sticky",
                    zIndex: 2,
                  }}
                >
                  <Col span={12}>
                    <Button
                      style={{ width: "100%", margin: "0px" }}
                      size="large"
                      className="skip-button"
                      onClick={() => {
                        onSkipSectionChange();
                      }}
                    >
                      Skip
                    </Button>
                  </Col>
                  {ocrConfirmedFiles.length === 0 ? (
                    <Col span={12}>
                      <Button
                        style={{ width: "100%", margin: "0px" }}
                        size="large"
                        className="enter-button"
                        onClick={onClickProceed}
                      >
                        Proceed
                      </Button>
                    </Col>
                  ) : (
                    <Col span={12}>
                      <Button
                        style={{ width: "100%", margin: "0px" }}
                        size="large"
                        className="enter-button"
                        onClick={onClickSubmit}
                      >
                        Submit
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </Form>
          ) : (
            <div className="exist-content">
              {addFleet ? (
                <div className="addfleet-detail">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Card
                        title={
                          <div className="card-title">
                            {t("FLEET_TRUCKS_BASIC_INFORMATION")}
                          </div>
                        }
                      >
                        <div className="img-div-truck">
                          <img src={EmptyTruck} alt="Truck" />
                        </div>
                        <div className="details-rows-truck">
                          <Row gutter={[8, 8]} className="data-row">
                            <Col span={8}>
                              <span>{t("FLEET_TRUCKS_PLATE_NO")}</span>
                              <Space className="country-detail">
                                <div className="country-name">
                                  <img src={TurkeyFlag} />
                                  <div>
                                    {truckData?.operatingCountry ===
                                    "United Arab Emirates"
                                      ? "UAE"
                                      : truckData?.operatingCountry
                                      ? truckData?.operatingCountry
                                      : "NA"}
                                  </div>
                                </div>
                                <span>
                                  {truckData?.assetPlateNumber
                                    ? truckData?.assetPlateNumber
                                    : "NA"}
                                </span>
                              </Space>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_TRUCKS_TRUCK_TYPE")}</span>
                              <span>
                                {truckData?.truckType
                                  ? truckData?.truckType
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_TRUCKS_STATUS")}</span>{" "}
                              <div className="booked-status">
                                {truckData?.portalStatus
                                  ? truckData?.portalStatus
                                  : "NA"}
                              </div>
                            </Col>
                          </Row>
                          <Row gutter={[8, 8]} className="data-row">
                            <Col span={8}>
                              <span>
                                {t("FLEET_TRUCKS_MANUFACTURING_YEAR")}
                              </span>
                              <span>
                                {truckData?.manufacturingYear
                                  ? truckData?.manufacturingYear
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_TRUCKS_REGISTRATION_CITY")}</span>
                              <span>
                                {truckData?.registrationCity
                                  ? truckData?.registrationCity
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={8}>
                              <span>{t("FLEET_TRUCKS_BRAND_NAME")}</span>
                              <span>
                                {truckData?.brandName
                                  ? truckData?.brandName
                                  : "NA"}
                              </span>
                            </Col>
                          </Row>
                          <Row gutter={[8, 8]} className="data-row">
                            <Col span={10}>
                              <span>
                                {t("FLEET_TRUCKS_NO_PLATE_ISSUER_NAME")}
                              </span>
                              <span>
                                {truckData?.plateNumberIssuerName
                                  ? truckData?.plateNumberIssuerName
                                  : "NA"}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </Col>

                    <Col span={12}>
                      <Card
                        title={
                          <div className="card-title">
                            {t("FLEET_TRUCKS_UPLOADED_DOC")}
                          </div>
                        }
                      >
                        <div>
                          <Row gutter={16} className="data-row">
                            <Col span={10}>
                              <span className="trucks-span">
                                {t("FLEET_TRUCKS_RC_DOC")}
                              </span>
                            </Col>
                            <Col span={14} className="doc-file">
                              <Row
                                justify={"end"}
                                style={{
                                  flexDirection: "column",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <Col sm={12}>
                                  <Fileupload
                                    filetype={DocTypes.TRUCK_FRONT}
                                    defaultThumbFile={documentUtility.getThumbnailImagePath(
                                      truckData?.regCertificate
                                        ? truckData?.regCertificate?.frontDoc
                                            ?.documentPath
                                        : "NA"
                                    )}
                                    defaultFile={
                                      truckData?.regCertificate
                                        ? truckData?.regCertificate?.frontDoc
                                            ?.documentPath
                                        : "NA"
                                    }
                                    fileName={""}
                                    entityId=""
                                    entityType={EntityTypes.TRUCK}
                                    accessFile={false}
                                    name={t("KYC_UPLOAD_FRONT_LBL")}
                                    readonly={true}
                                  />
                                </Col>
                                <Col sm={12}>
                                  <Fileupload
                                    filetype={DocTypes.TRUCK_BACK}
                                    defaultThumbFile={documentUtility.getThumbnailImagePath(
                                      truckData?.regCertificate
                                        ? truckData?.regCertificate?.backDoc
                                            ?.documentPath
                                        : "NA"
                                    )}
                                    defaultFile={
                                      truckData?.regCertificate
                                        ? truckData?.regCertificate?.backDoc
                                            ?.documentPath
                                        : "NA"
                                    }
                                    fileName={""}
                                    entityId=""
                                    entityType={EntityTypes.TRUCK}
                                    accessFile={false}
                                    name={t("KYC_UPLOAD_BACK_LBL")}
                                    readonly={true}
                                  />
                                </Col>
                                {/* <img src={truckData?.regCertificate ? truckData?.regCertificate?.backDoc?.documentPath : "NA"} alt="alt" /> */}
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={16} className="data-row">
                            <Col span={10}>
                              <span>{t("FLEET_TRUCKS_REGISTRATION_NO")}</span>
                              <span>
                                {truckData?.regCertificate
                                  ? truckData?.regCertificate?.documentNumber
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={14}>
                              <span>{t("FLEET_TRUCKS_EXPIRY_DATE")}</span>
                              <span>
                                {truckData?.regCertificate
                                  ? moment(
                                      truckData?.regCertificate?.expiryDate
                                    ).format(dateFormat)
                                  : "NA"}
                              </span>
                            </Col>
                          </Row>

                          {truckData.isTrailerDocument && (
                            <>
                              <div className="bottom-border"></div>

                              <Row gutter={16} className="data-row">
                                <Col span={10}>
                                  <span className="trucks-span">
                                    {t("FLEET_TRUCKS_RC_DOC")}
                                  </span>
                                </Col>
                                <Col span={14} className="doc-file">
                                  <Row
                                    justify={"end"}
                                    style={{
                                      flexDirection: "column",
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <Col sm={12}>
                                      <Fileupload
                                        filetype={DocTypes.TRUCK_TRAILER_FRONT}
                                        defaultThumbFile={documentUtility.getThumbnailImagePath(
                                          truckData?.trailerRegCertificate
                                            ? truckData?.trailerRegCertificate
                                                ?.frontDoc?.documentPath
                                            : "NA"
                                        )}
                                        defaultFile={
                                          truckData?.trailerRegCertificate
                                            ? truckData?.trailerRegCertificate
                                                ?.frontDoc?.documentPath
                                            : "NA"
                                        }
                                        fileName={""}
                                        entityId=""
                                        entityType={EntityTypes.TRUCK}
                                        accessFile={false}
                                        name={t("KYC_UPLOAD_FRONT_LBL")}
                                        readonly={true}
                                      />
                                    </Col>
                                    <Col sm={12}>
                                      <Fileupload
                                        filetype={DocTypes.TRUCK_TRAILER_BACK}
                                        defaultThumbFile={documentUtility.getThumbnailImagePath(
                                          truckData?.trailerRegCertificate
                                            ? truckData?.trailerRegCertificate
                                                ?.backDoc?.documentPath
                                            : "NA"
                                        )}
                                        defaultFile={
                                          truckData?.trailerRegCertificate
                                            ? truckData?.trailerRegCertificate
                                                ?.backDoc?.documentPath
                                            : "NA"
                                        }
                                        fileName={""}
                                        entityId=""
                                        entityType={EntityTypes.TRUCK}
                                        accessFile={false}
                                        name={t("KYC_UPLOAD_BACK_LBL")}
                                        readonly={true}
                                      />
                                    </Col>
                                    {/* <img src={truckData?.regCertificate ? truckData?.regCertificate?.backDoc?.documentPath : "NA"} alt="alt" /> */}
                                  </Row>
                                </Col>
                              </Row>
                              <Row gutter={16} className="data-row">
                                <Col span={10}>
                                  <span>
                                    {t("FLEET_TRUCKS_REGISTRATION_NO")}
                                  </span>
                                  <span>
                                    {truckData?.trailerRegCertificate
                                      ? truckData?.trailerRegCertificate
                                          ?.documentNumber
                                      : "NA"}
                                  </span>
                                </Col>
                                <Col span={14}>
                                  <span>{t("FLEET_TRUCKS_EXPIRY_DATE")}</span>
                                  <span>
                                    {truckData?.trailerRegCertificate
                                      ?.expiryDate
                                      ? moment(
                                          truckData?.trailerRegCertificate
                                            ?.expiryDate
                                        ).format(dateFormat)
                                      : "NA"}
                                  </span>
                                </Col>
                              </Row>
                            </>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="exist-content">
                  <img src={ExistsImg} alt="" />
                  <span>
                    {" "}
                    {t("TRUCK_NO_KEY")}{" "}
                    {addTruckForm.getFieldValue("assetPlateNumber")}{" "}
                    {t("ALREADY_EXIST_KEY")}. {t("ADD_IN_YOUR _FLEET_KEY")}
                  </span>
                </div>
              )}
              <div className="button-row">
                <Button
                  type="secondary"
                  className="cancel-btn"
                  onClick={() => {
                    setAddFleet(false);
                    setTruckExist(false);
                  }}
                >
                  {addFleet ? t("TRY_ANOTHER_TRUCK_KEY") : t("COMMON_NO_BTN")}
                </Button>
                <Button
                  type="secondary"
                  loading={btnLoader}
                  className="submit-btn"
                  onClick={addTruckinFleetHandler}
                >
                  {addFleet ? t("ADD_TRUCK_KEY") : t("COMMON_YES_BTN")}
                </Button>
              </div>
            </div>
          )}
        </div>
        {warningModal && (
          <Modal
            open={warningModal}
            centered
            maskClosable={false}
            width={"30rem"}
            onOk={() => {
              setWarningModal(false);
              onClose();
            }}
            onCancel={() => {
              setWarningModal(false);
            }}
            title={
              <div className="title-modal">
                <span>{t("WARNING_KEY")}</span>
                <WarningOutlined />
              </div>
            }
            className="warning-modal"
            okText={t("COMMON_YES_BTN")}
            cancelText={t("COMMON_NO_BTN")}
          >
            <div className="warning-div">
              <span>{t("UNSAVED_CHANGES_CANCEL_BTN")}?</span>
            </div>
          </Modal>
        )}
      </Modal>
      {/*  *********** Upload Document Drawer  ************ */}
      <Drawer
        className="drawer-upload"
        title={
          <>
            <div className="drawer-title">
              Upload Document
              <Button
                icon={<CloseOutlined />}
                type="text"
                onClick={() => setOpenDrawer(false)}
                style={{ fontSize: "16px" }}
              />
            </div>
          </>
        }
        onClose={() => {
          setOpenDrawer(false);
        }}
        closable={false}
        open={openDrawer}
        styles={{
          header: {
            padding: "0",
            border: "none",
          },
          body: {
            padding: "0",
            position: "relative",
          },
        }}
      >
        <>
          <div className="drawer-upload-body">
            <OCRFileUpload
              // onChange={handleFileChange}
              onChange={handleOCRConformFileChange}
              uploadedFiles={ocrConfirmedFiles}
              // onDelete={handleFileDelete}
              onDelete={handleOCRConfirmFileDelete}
            />
          </div>
          <Row
            justify="center"
            gutter={8}
            style={{
              width: "100%",
              bottom: 0,
              position: "absolute",
            }}
          >
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="skip-button"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="submit-button"
                onClick={handleDrawerFileSubmit}
                disabled={false}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </>
      </Drawer>
      {/* ************************ Missing Doc Modal **************** */}
      <Modal
        open={missingDocModal}
        footer={null}
        closable={false}
        width={400}
        onCancel={() => setMissingDocModal(false)}
        centered
        style={{ textAlign: "center", padding: "16px 16px 32px 16px" }}
      >
        <MissingDocModal
          onClose={() => setMissingDocModal(false)}
          handleMissingDocSubmit={() => {
            setMissingDocModal(false);
            setNextBtn(true);
            setIsOcrFileUpload(false);
          }}
          isFileUploaded={!ocrParsedData && ocrConfirmedFiles.length > 0}
        />
      </Modal>
      {/* // modal trigger only for plate number changes // */}
      <Modal
        open={showPlateMismatchModal}
        // onOk={() => {
        //   // Accept OCR plate number

        //   setFormValues((prev) => ({
        //     ...prev,
        //     assetPlateNumber: ocrPlateNumber,
        //     truckRegistrationNo: ocrPlateNumber,
        //   }));
        //   addTruckForm.setFieldsValue({
        //     assetPlateNumber: ocrPlateNumber,
        //     truckRegistrationNo: ocrPlateNumber,
        //   });
        //   setShowPlateMismatchModal(false);
        // }}
        onOk={useOcrPlateHandler}
        onCancel={() => {
          setShowPlateMismatchModal(false);
          setNextBtn(true);
          setIsOcrFileUpload(false);
        }}
        width={400}
        centered
        style={{ textAlign: "center", padding: "16px 16px 32px 16px" }}
        title="Mismatch Detected"
        okText="Use OCR Plate"
        cancelText="Keep Uploaded Plate"
      >
        <p>
          The truck plate number detected from OCR (
          <strong>{ocrPlateNumber}</strong>) is different from the one in
          uploaded document (<strong>{formValues.assetPlateNumber}</strong>).
          <br />
          Do you want to use the OCR-detected plate number?
        </p>
      </Modal>

      {/* DISCARD MODAL */}
      <DiscardWarningModal
        visible={isDiscardModalVisible}
        onOk={() => handleProceedDiscardOcrData()}
        onCancel={() => setIsDiscardModalVisible(false)}
      />
    </>
  );
};

export default AddTruck;
